import { render, staticRenderFns } from "./StudentsExercisesDetail.vue?vue&type=template&id=1878349a&scoped=true&"
import script from "./StudentsExercisesDetail.vue?vue&type=script&lang=js&"
export * from "./StudentsExercisesDetail.vue?vue&type=script&lang=js&"
import style0 from "./StudentsExercisesDetail.vue?vue&type=style&index=0&id=1878349a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1878349a",
  null
  
)

export default component.exports